import React from 'react';
import { useDispatch } from 'react-redux';
import { SolutionCenterContentTypes, ZendeskSearchArticle } from '../../../types/solution-center';
import { setSolutionCenterContentState } from '../../../stores/actions/user-interface';
import PaginationControls from '../pagnation-controls';
import {
	SolutionCenterUl,
	SearchItem,
	SearchItemTitle,
	SearchItemBreadcrumbs,
	SearchItemSnippet,
	SolutionCenterC2Text,
	LoadingContainer,
} from '../elements';
import ComingSoon from '../../general-components/coming-soon';
import TellySad from '../../../images/telly-sad.svg';
import LoadingSpinner, { LoadingSpinnerType } from '../../general-components/loading-spinner';

interface SearchViewProps {
	isSearching: boolean;
	searchString: string;
	currentPage: number;
	totalPages: number;
	searchResults: ZendeskSearchArticle[];
	handleSearch: (searchString: string) => void;
	handleSelectCategory: (categoryId: number) => void;
	handleSelectSection: (sectionId: number) => void;
}

export default function SearchView(props: SearchViewProps) {
	const dispatch = useDispatch();

	const {
		isSearching,
		searchString,
		currentPage,
		totalPages,
		searchResults,
		handleSearch,
		handleSelectCategory,
		handleSelectSection,
	} = props;

	return (
		<>
			{isSearching ? (
				<LoadingContainer>
					<LoadingSpinner
						height={36}
						width={36}
						type={LoadingSpinnerType.Gradient}
						style={{ background: '#26242B' }}
					/>
				</LoadingContainer>
			) : (
				<SolutionCenterUl>
					{searchResults.length > 0 ? (
						searchResults.map((s) => (
							<SearchItem key={`search-article-${s.id}`}>
								<SearchItemTitle
									className="truncate"
									onClick={() => dispatch(setSolutionCenterContentState({
										id: s.id,
										type: SolutionCenterContentTypes.Article,
									}))}
								>
									{s.title}
								</SearchItemTitle>
								<SearchItemBreadcrumbs>
									<SearchItemTitle onClick={() => handleSelectCategory(s.category_id)}>
										{s.category_name}
									</SearchItemTitle>
									<SearchItemTitle style={{ cursor: 'default' }}>
										&nbsp;&gt;&nbsp;
									</SearchItemTitle>
									<SearchItemTitle className="truncate" onClick={() => handleSelectSection(s.section_id)}>
										{s.section_name}
									</SearchItemTitle>
								</SearchItemBreadcrumbs>
								<SearchItemSnippet dangerouslySetInnerHTML={{ __html: s.snippet }} />
								<SolutionCenterC2Text className="date">
									Updated&nbsp;
									{new Date(s.updated_at).toLocaleDateString('en-US', {
										year: 'numeric',
										month: 'long',
										day: 'numeric',
										hour: '2-digit',
										minute: 'numeric',
									})}
								</SolutionCenterC2Text>
							</SearchItem>
						))
					) : (
						<ComingSoon
							title="Nothing to see here... yet."
							body="We couldn't find anything that matches your search.&#10;Try that again using different keywords."
							className="no-results"
							tellyImage={TellySad}
						/>
					)}
				</SolutionCenterUl>
			)}
			<PaginationControls
				isLoading={isSearching}
				currentPage={currentPage}
				totalPages={totalPages}
				onPageChange={(newPage: number) => {
					handleSearch(`${searchString}&page=${newPage}`);
				}}
			/>
		</>
	);
}
